/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme } from "@mui/material";

export const conversationTableRowGroupStyle = {
  row: {
    padding: 0,
    cursor: "pointer",
  },
  column: {
    borderBottom: "none",
    padding: "1rem 0",
  },
  columnBorder: (theme: Theme) => ({
    borderBottom: `1px solid ${theme.palette.divider}`,
  }),
  columnCenter: {
    padding: "1rem",
    paddingLeft: { xs: "0rem", md: "1rem" },
  },
  columnAlert: {
    paddingTop: 0,
  },
  icon: {
    marginLeft: "0.25rem",
  },
  unreadIconContainer: (theme: Theme) => ({
    position: "relative",
    "&::before": {
      content: "''",
      position: "absolute",
      width: "0.75rem",
      aspectRatio: "1/1",
      borderRadius: "50%",
      top: 0,
      right: 0,
      backgroundColor: theme.palette.warning.main,
      transform: "translateX(0) translateY(-15%)",
    },
  }),
};
